'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M23 12.067C23 5.954 18.076 1 12 1S1 5.954 1 12.067C1 17.592 5.022 22.17 10.281 23v-7.734H7.488v-3.199h2.793V9.63c0-2.773 1.642-4.306 4.155-4.306 1.204 0 2.462.216 2.462.216v2.724h-1.387c-1.367 0-1.792.854-1.792 1.73v2.074h3.05l-.487 3.2h-2.563V23C18.979 22.17 23 17.592 23 12.067" /></svg>;
const IconSocialFacebook = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconSocialFacebook;